import Request from ".";
import { Routes } from "../constant/api_url";

export const getLeaveSettings = async () => {
  const result = await Request.post(Routes.ADMIN_GETLEAVESETTINGS, {}, {
    headers: { Accept: "application/json, */*", "Content-Type": "application/json" }
  });
  return result.data;
};

export const updateLeaveSettings = async (data) => {
  const result = await Request.post(Routes.ADMIN_UPDATELEAVESETTINGS, data, {
    headers: { Accept: "application/json, */*", "Content-Type": "application/json" }
  });
  return result.data;
};

export const getLeavePolicyVersions = async () => {
  const result = await Request.post(Routes.ADMIN_GETLEAVEPOLICYVERSIONS, {}, {
    headers: { Accept: "application/json, */*", "Content-Type": "application/json" }
  });
  return result.data;
};

export const publishLeavePolicy = async (data) => {
  const result = await Request.post(Routes.ADMIN_PUBLISHLEAVEPOLICY, data, {
    headers: { Accept: "application/json, */*", "Content-Type": "application/json" }
  });
  return result.data;
};
